import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import StatusBadge from "@/components/StatusBadge";
import { formatDate } from "@/lib/status";
import { FLAGGED } from "@/components/HomeStats";
import { useI18n } from "@/context/I18nContext";

export const RecentlyFlagged = ({ facilities, loading }) => {
  const { t } = useI18n();
  const flagged = facilities
    .filter((f) => FLAGGED.includes(f.status))
    .sort((a, b) => (b.status_updated_at || "").localeCompare(a.status_updated_at || ""))
    .slice(0, 6);

  return (
    <section className="mx-auto max-w-6xl px-4 sm:px-6 pt-10 sm:pt-14" data-testid="recently-flagged-section">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="font-heading text-2xl font-bold text-slate-900">{t("flagged.title")}</h2>
        <Link to="/traveler-alert" className="text-sm font-semibold text-blue-700 hover:underline" data-testid="flagged-see-all">
          {t("flagged.seeAll")}
        </Link>
      </div>
      <p className="mt-1 text-sm text-slate-600">{t("flagged.body")}</p>
      <div className="mt-4 grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        {loading && [1, 2, 3].map((i) => <Skeleton key={i} className="h-28 rounded-lg" />)}
        {!loading && flagged.map((f) => (
          <Card key={f.id} className="relative p-4 border-slate-200 hover:border-slate-900 transition-colors" data-testid={`flagged-card-${f.id}`}>
            <StatusBadge status={f.status} size="sm" />
            <Link to={`/facility/${f.id}`} className="mt-2 block font-heading font-bold text-slate-900 after:absolute after:inset-0">
              {f.name}
            </Link>
            <div className="mt-1 text-xs text-slate-600">{[f.city, f.state].filter(Boolean).join(", ")}</div>
            <div className="mt-2 font-mono text-[10px] uppercase tracking-widest text-slate-500">{t("flagged.updated")} {formatDate(f.status_updated_at)}</div>
          </Card>
        ))}
        {!loading && flagged.length === 0 && (
          <Card className="p-4 md:col-span-2 lg:col-span-3 border-emerald-200 bg-emerald-50 text-sm text-slate-700" data-testid="flagged-empty">
            {t("flagged.empty")}
          </Card>
        )}
      </div>
    </section>
  );
};
